<div class="truncatedContentTooltip">
    <div class="tooltipText">{{ data?.fullText }}</div>
</div>
